module.exports = __webpack_public_path__ + "static/media/life-overview-tutorial-btn.65de8ddc.png";